import React, { useState } from "react";

import { IActivityManagementWorkflow } from "../../../../../../context/interfaces/IWorkflowContext";
import PerformedActivities from "./PerformedActivities";
import NotPerformedActivities from "./NotPerformedActivities";

interface IModalProps {
    workflow: IActivityManagementWorkflow | null;
    changeModalTitle: (title: string) => void;
}

const PERFORMED = "PERFORMED";
const NOT_PERFORMED = "NOT_PERFORMED";

const ActivitiesManagementDetails: React.FC<IModalProps> = ({
    workflow,
    changeModalTitle,
}) => {
    const [content, setContent] = useState<string>(PERFORMED);

    const showPerformed = content === PERFORMED && (
        <PerformedActivities
            workflow={workflow}
            handleChangeContent={(value: string) => setContent(value)}
            changeModalTitle={changeModalTitle}
        />
    );

    const showNotPerformed = content === NOT_PERFORMED && (
        <NotPerformedActivities
            workflow={workflow}
            handleChangeContent={(value: string) => setContent(value)}
            changeModalTitle={changeModalTitle}
        />
    );

    return (
        <>
            {showPerformed}
            {showNotPerformed}
        </>
    );
};

export default ActivitiesManagementDetails;
